import { lazy } from 'react'

export const retryImport = (factory, retries = 3, interval = 500) =>
  factory().catch((error) => {
    if (retries <= 1) throw error
    return new Promise((resolve) => setTimeout(resolve, interval))
      .then(() => retryImport(factory, retries - 1, interval))
  })

export const lazyWithRetry = (factory) => lazy(() => retryImport(factory))
